"use client";

import React from "react";
import Image from "next/image"; 
import styles from "./TemokGuarn.module.css";

import AbtFrm from "../../../public/growth.jpg";

const TemokGuarn = () => (
  <section className={styles.sectionWrapper}>
    <div className="container">
      <div className="row align-items-center">
        {/* ----- IMAGE ----- */}
        <div className="col-lg-5 col-md-12 text-center">
          <div className="" >
            <Image
              src={AbtFrm}
              alt="About Temok"
              className="img-fluid rounded-4"
              width={500}
              height={300}
            />
          </div>
        </div>
        {/* ----- CONTENT ----- */}
        <div className="col-lg-7 col-md-12">
          <h1 className={`${styles.heading} display-6`}>
          Your Growth Starts Here
          </h1>

          <p className={`${styles.description} fs-5`}>
          Whether you’re building a startup, powering an online store, deploying enterprise applications, or scaling global cloud operations — Temok is the infrastructure partner you can rely on.
          </p>

          <p className={`${styles.description} fs-5`}>
We&apos;re here to keep your business online, secure, and blazing-fast — every second of every day.<br/><br/>
Let&apos;s build the future of your digital presence together.
          </p>
 
        </div>

        

      </div>
    </div>
  </section>
);

export default TemokGuarn;
